import classNames from 'classnames'

import { getQaSelector } from '../../../../utils/common'
import {
  ICON_CHEVRON_DIRECTION,
  ICON_COLOR,
  ICON_HEIGHT_16,
  IconChevron,
  IconNG,
} from '../../../Icon'
import {
  MATCH_SCORE_RING_SIZE,
  QA_NAME_MATCH_FIT_CELL,
} from '../RentalPortalMatch.constants'
import { RentalPortalMatchEligibilityBadge } from '../RentalPortalMatchEligibilityBadge'

import { RentalPortalMatchFitCellScore } from './RentalPortalMatchFitCellScore'

import * as styles from './RentalPortalMatchFitCell.module.css'

function RentalPortalMatchFitCell({
  className = styles.RentalPortalMatchFitCell,
  isCompact,
  isScoreOnly,
  match,
  ringSize = MATCH_SCORE_RING_SIZE.table,
}) {
  return (
    <div
      {...getQaSelector({ value: QA_NAME_MATCH_FIT_CELL })}
      className={classNames(className, {
        [styles.compact]: isCompact,
        [styles.scoreOnly]: isScoreOnly,
      })}
    >
      {isScoreOnly ? null : (
        <RentalPortalMatchEligibilityBadge
          className={styles.badge}
          hasReason={false}
          match={match}
        />
      )}
      <RentalPortalMatchFitCellScore
        isScoreOnly={isScoreOnly}
        match={match}
        ringSize={ringSize}
      />
      {isCompact || isScoreOnly ? null : (
        <IconNG
          Icon={IconChevron}
          color={ICON_COLOR.SecondaryTextColor}
          iconProps={{ direction: ICON_CHEVRON_DIRECTION.RIGHT }}
          size={ICON_HEIGHT_16}
        />
      )}
    </div>
  )
}

export default RentalPortalMatchFitCell
